import { createDebugger } from '@iotize/common/debug';

const prefix = '@iotize/tap/client/impl';

export const debug = createDebugger(prefix);
